const initialPage = 1;
const initialSizePage = 10;

export const catFilter = (dataForm) => ({
  idProcesoElectoral: dataForm.idProcesoElectoral,
  ambito: dataForm.ambito,
  idProceso: dataForm.idProcesoEspecifico,
  idTipoAsociacion: dataForm.idTipoAsociacion
});

export const tableBeneficiados = (dataForm) => ({
  ...catFilter(dataForm),
  sujetoObligado: dataForm.sujetoObligadoIdentificar.trim(),
  cantidad: initialSizePage,
  pagina: initialPage
});

export const filterTableBeneficiados = (dataForm, filters) => ({
  ...tableBeneficiados(dataForm),
  nombreBeneficiado: filters.nombreBeneficiado,
  cargo: filters.cargo,
  entidad: filters.estado,
  tipoBeneficio: filters.tipoBeneficio,
  folio: filters.folio
});

export const tableCandiatosAp = (dataForm) => {
  const { sujetoObligado, ...restPayload } = tableBeneficiados(dataForm);
  return { ...restPayload, idSujetoObligadoSIF: dataForm.idSujetoObligadoAprobados };
};

export const filterTableCandiatosAp = (dataForm, filters) => ({
  ...tableCandiatosAp(dataForm),
  nombreCandidatoSIF: filters.nombreCandidato,
  cargo: filters.cargo,
  entidadSIF: filters.estado,
  cuentaSIF: filters.cuentaRF,
  correoSIF: filters.correoRF
});

export const actualizarBeneficiado = (dataSourceBeneficiados, candidatoAprobadoChecked) => {
  const idsBeneficiados = dataSourceBeneficiados
    .filter((beneficiado) => beneficiado.selecciona === true)
    .map((ben) => ({
      idBeneficiado: ben.idBeneficiado,
      idTipoBeneficio: ben.idTipoBeneficio,
      idCMonitoreo: ben.idCMonitoreo,
      idMonitoreo: ben.idMonitoreo,
      idHallazgo: ben.idHallazgo,
      idCActa: ben.idCActa,
      cargo: ben.idTipoBeneficio === 1 ? null : ben.cargo,
      nombreBeneficiado: ben.idTipoBeneficio === 1 ? null : ben.nombreBeneficiado
    }));
  return {
    idsBeneficiados,
    candidatosApSIF: [candidatoAprobadoChecked]
  };
};
